import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { getKey, onCellsChanged, toString } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import { gridShortDate } from 'utilities/dateFormats';
import {
  ColConfigProps,
  EffectiveTaxRateLedgerParserParams,
  RowConfigProps,
  TCells,
  TChanges,
  ValueType,
} from '../types';

const customParser = async (params: EffectiveTaxRateLedgerParserParams) => {
  const { columns, initialObject, isDisabled, rowConfig, tableId } = params;
  let cells: TCells = {};
  const changes: TChanges[] = [];
  const alphabet = alphabetGenerator([], columns.length);

  rowConfig.forEach((row: RowConfigProps, rowIdx: number) => {
    columns.forEach((col: ColConfigProps, colIdx: number) => {
      const columnLegend = alphabet[colIdx];
      const key = getKey(row.alias, colIdx, tableId);
      let value: ValueType = null;

      if (col.alias === 'value') {
        const auxValue = initialObject[rowIdx].value ?? '';
        value = row.dbType === 'dbDate' ? toString(gridShortDate(auxValue)) : auxValue;
      } else {
        value = row.value ?? '';
      }

      const cell = {
        ...col,
        ...row,
        columnLegend,
        key,
        alias: row.alias ?? '',
        colAlias: col.alias ?? '',
        rowAlias: row.alias ?? '',
        colNumber: colIdx,
        rowNumber: rowIdx,
        value,
        className: colIdx === 1 ? 'text-right' : row.className,
        insideLedger: true,
        tableId,
        readOnly: colIdx === 1 && col.alias === 'value' ? isDisabled : true,
      } as ICell;
      cells[key] = cell;
      changes.push({ cell, value });
    });
  });

  cells = await onCellsChanged(changes, cells);
  return cells;
};

export default customParser;
